import { Form, message } from 'antd';
import styles from './searchGroup.less?modules';
import ButtonML from '@/components/button_ml/ButtonML';
import SelectML from '@/components/select_ml/SelectML';
import { useDispatch } from 'dva';
import { useState } from 'react';
const SearchGroup = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [versionList, setVersionList] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const { onClick, resetInput, onVersion } = props || {};
  const onFinish = (values) => {
    for (let key in values) {
      if (!values[key]) {
        message.warning('请将数据填写完整再执行');
        return;
      }
    }
    props.handleSearch(values);
  };

  const onReset = () => {
    form.resetFields();
    // props.handleSearch({});
  };
  const addRule = () => {
    const values = form.getFieldsValue();
    for (let key in values) {
      if (!values[key]) {
        message.warning('请将数据填写完整再执行');
        return;
      }
    }
    onClick && onClick(values);
  };

  // 重置版本号
  const resetFiledVersion = () => {
    let fileValues = form.getFieldValue();
    fileValues.version = undefined;
    form.setFieldsValue({
      ...fileValues,
    });
  };
  const selectDecision = (e, m) => {
    resetFiledVersion();
    if (e === undefined) {
      setDisabled(true);
    } else {
      resetInput && resetInput();
      dispatch({
        type: 'dvm/getVersion',
        payload: {
          values: {
            diagramName: m.children,
          },
        },
        callback: (res) => {
          let result = [];
          res &&
            res.forEach((item) => {
              result.push({ value: item, name: item });
            });
          setVersionList(result);
          setDisabled(false);
        },
      });
    }
  };

  const selectVersion = () => {
    const values = form.getFieldsValue();
    for (let key in values) {
      if (!values[key]) {
        message.warning('请将数据填写完整再执行');
        return;
      }
    }
    onVersion(values);
  };

  return (
    <Form
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      className={styles.serarchFrom}
    >
      {/* 会员号 */}
      {/* <Col span={8}> */}
      <div className={styles.input_contain}>
        {/* 决策图名称 */}
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="210px"
          maxWidth="210px"
          labelVal="决策图名称"
          placeVal="请选择决策图名称"
          name="strategyCode"
          option={props.options}
          allowClear={true}
          onChange={selectDecision}
        />
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="210px"
          labelVal="版本号"
          placeVal="请输入版本号"
          name="version"
          allowClear={true}
          disabled={disabled}
          option={versionList}
          onChange={selectVersion}
          // icon={}
        />
        {/* <SingInputML
          height="37px"
          labelwidth="130px"
          inputWidth="200px"
          labelVal="版本类型"
          placeVal="请输入版本类型"
          name="strategyCode"
          allowClear={true}
          // icon={}
        /> */}
        {/* <SingInputML
          height="37px"
          labelwidth="130px"
          inputWidth="200px"
          labelVal="用户编号"
          placeVal="请输入用户编号"
          name="userNo"
          allowClear={true}
          // icon={}
        /> */}
      </div>

      <div className={styles.btn_contain}>
        <ButtonML size="large" value="确认" fontsize="16px" onClick={addRule} />
        <ButtonML size="large" value="重置" fontsize="16px" onClick={onReset} />
        {/* <ButtonML
          size="large"
          value="查询"
          htmlType="submit"
          // width="106px"
          // height="46px"
          fontsize="16px"
        /> */}
      </div>
    </Form>
  );
};

export default SearchGroup;
